import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles( theme => ({
  card: {
    ...theme.custom1,
    backgroundColor: 'white',
    height: '540px',
    overflow: 'hidden',
    position: 'relative' // some content in cards is 'absolute' WRT the card
  },
  header: {
    ...theme.custom2,
    borderBottom: '0.5px solid #DFE3E8',
    fontFamily: 'Roboto',
    fontSize: '10px',
    fontWeight: '700',
    lineHeight: '12px',
    textTransform: 'uppercase',
    padding: '15px 20px'
  },
  section: {
    padding: '12px 20px',
    borderBottom: '0.5px solid #DFE3E8',
    '&:last-child': {
      borderBottom: 'none'
    }
  }
}));

export const CardHeader = ({ children, className='', ...rest }) => {
  let classes = useStyles();
  return <div className={`${classes.header} ${className}`} {...rest}>
    {children}
  </div>;
}
export const CardSection = ({ children, className='', ...rest }) => {
  let classes = useStyles();
  return <div className={`${classes.section} ${className}`} {...rest}>
    {children}
  </div>;
}

export default function Card({ children, className='', ...rest }) {
  let classes = useStyles();
  return <div className={`${classes.card} ${className}`} {...rest}>
    {children}
  </div>;
}